interface InsufficientExternalPoolError {
  error: string;
  available: string;
  requested: string;
}

interface SourcesSmetaMismatchError {
  error: string;
  sources_total: string;
  smeta_total: string;
}

function getErrorData(error: unknown): Record<string, unknown> | null {
  if (
    typeof error === "object" &&
    error !== null &&
    "data" in error &&
    typeof (error as Record<string, unknown>).data === "object" &&
    (error as Record<string, unknown>).data !== null
  ) {
    return (error as Record<string, Record<string, unknown>>).data;
  }
  return null;
}

function getFieldCode(error: unknown, field: string): string | null {
  const data = getErrorData(error);
  if (!data) return null;
  const code = data[field];
  return typeof code === "string" ? code : null;
}

function getErrorCode(error: unknown): string | null {
  return getFieldCode(error, "error");
}

export function isInsufficientExternalPoolError(
  error: unknown,
): error is { data: InsufficientExternalPoolError } {
  const code = getErrorCode(error);
  return code === "insufficient_external_pool_budget" || code === "insufficient_dotted_pot_budget";
}

export function isSourcesSmetaMismatchError(
  error: unknown,
): error is { data: SourcesSmetaMismatchError } {
  return getErrorCode(error) === "sources_smeta_mismatch";
}

export function isExternalSmetaReadonlyError(error: unknown): boolean {
  return getFieldCode(error, "planned") === "external_smeta_is_readonly" || getErrorCode(error) === "external_smeta_is_readonly";
}

export function isInternalImmutableError(error: unknown): boolean {
  return getFieldCode(error, "is_internal") === "is_internal_is_immutable" || getErrorCode(error) === "is_internal_is_immutable";
}
